export default {
  titles: 'Signature fields',
  defaultHint: 'The report shows these departments in its language until you change them.',
  titlePlaceholder: 'Signature field title',
  addTitle: 'Add signature field',
  titleTooLong: 'Enter at most {maxLength} characters.',
  restoreDefaults: 'Restore defaults',
  titleEmpty: 'Enter a title.',
  defaultDepartments: {
    material: 'Material',
    quality: 'Quality',
    engineering: 'Engineering',
    manufacturing: 'Manufacturing',
    program: 'Program',
    customer: 'Customer',
  },
};
